import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import DialogFieldGroupForm from './DialogFieldGroupForm';
import DialogFieldDateEditor from './DialogFieldDateEditor';
import DialogFieldStringEditor from './DialogFieldStringEditor';
import DialogFieldEnumEditor from './DialogFieldEnumEditor';
import DialogFieldBooleanEditor from './DialogFieldBooleanEditor';
import DialogFieldLongEditor from './DialogFieldLongEditor';
import DialogFieldDecimalEditor from './DialogFieldDecimalEditor';
import DialogFieldTimeEditor from './DialogFieldTimeEditor';
import DialogFieldLabel from './DialogFieldLabel';
import FormResourceUtil from '../../utils/FormResourceUtil';
import CommandActions from '../../actions/CommandActions';
import CommandHelper from '../../remote/CommandHelper';
import ServiceHelper from '../../remote/ServiceHelper';
import CommandResolver from '../../utils/CommandResolver';

class DialogForm extends React.Component
{

	constructor(props)
	{
		super(props);
		let dialogArg = this.props.dialogArg;
		let layout = dialogArg.layout;
		
		this.state = {controls:dialogArg.controls,layout:layout,title:dialogArg.title,okLabel:dialogArg.okLabel,cancelLabel:dialogArg.cancelLabel};
	}
	
	componentDidMount()
	{
		
		$(this.outterDiv).draggable({
			handle: ".modal-header"
		});
	}

	getDialogComponents()
	{
		let result = [];
		if(this.state.controls)
		{
			for(let i = 0;i<this.state.controls.length;i++)
			{
				let control = this.state.controls[i];
				if(control.hasOwnProperty("fields"))
				{
					result.push(
						<DialogFieldGroupForm key={i} data = {control} dialogId = {this.props.dialogArg.id}/>
					);
				}//TODO Flex版会把多出的field按照顺序分组 比如  group field field group field
				//结果为 group group group group
				else
				{
					if(control.editorType == "TypeString")
					{
						result.push(
							<DialogFieldStringEditor key={i} data={control} dialogId = {this.props.dialogArg.id}/>
						);
					}
					else if(control.editorType == "TypeEnum")
					{
						result.push(
							<DialogFieldEnumEditor key={i} data={control} dialogId = {this.props.dialogArg.id}/>
						);
					}
					else if(control.editorType == "TypeBoolean")
					{
						result.push(
							<DialogFieldBooleanEditor key={i} data={control} dialogId={this.props.dialogArg.id}/>
						);
					}
					else if(control.editorType == "TypeLabel")
					{
						result.push(
							<DialogFieldLabel key={i} data={control} dialogId={this.props.dialogArg.id}/>
						);	
					}
					else if(control.editorType == "TypeLong")
					{
						result.push(
							<DialogFieldLongEditor key={i} data={control} dialogId={this.props.dialogArg.id}/>
						);
					}
					else if(control.editorType == "TypeDecimal")
					{
						result.push(
							<DialogFieldDecimalEditor key={i} data={control} dialogId={this.props.dialogArg.id}/>
						);
					}
					else if(control.editorType == "TypeTime")
					{
						result.push(
							<DialogFieldTimeEditor key={i} data={control} dialogId={this.props.dialogArg.id}/>
						);
						
					}
					else
					{
						result.push(
							<DialogFieldDateEditor key={i} data={control} dialogId = {this.props.dialogArg.id}/>
						);
					}
				}
			}
		}
		return result;
	}

	closeDialogFormHandler()
	{
		this.do_server("Close");
	}

	doCloseDialogFormHandler()
	{
		let $reactComponentContainer = $("#dialogModal .modal");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		$reactComponentContainer.remove();
	}

	do_server(cmd)
	{
		if(this.dialogIsClicking == true){
			return;
		}
		this.dialogIsClicking = true;
		let that = this;
		setTimeout(function(){
			that.dialogIsClicking = false;
		},400);
		if(!window.formModuleInstance)
			return;
		
		let formId = window.formModuleInstance.formId;
		
		//暂定Dialog就是无数据源
		let group = null;let groupAlias = this.props.dialogArg.groupAlias;
		if(window.formModuleInstance.formDataSources)
		{
			if(groupAlias)
			{
				group = window.formModuleInstance.formDataSources.groups[groupAlias];
			}
			else
			{
				group = window.formModuleInstance.formDataSources.currentGroup;
				if(group == null)
					group = window.formModuleInstance.formDataSources.firstGroup;
			}
		}
		
		let defaultGroupAlias = !group?null:group.groupAlias;
		
		
		
		var _do;
		if(cmd=="OK")
		{
			_do = "dialogOK_" + this.props.dialogArg.id;
		}
		else if(cmd=="Cancel")
		{
			_do = "dialogCancel_" + this.props.dialogArg.id;
		}
		else if(cmd=="Close")
		{
			_do = "dialogClose_" + this.props.dialogArg.id;
		}
		else
		{
			return;	
		}
		
		var mi = FormResourceUtil.getCommandArgMethodInfo(_do);
		if(!mi)
		{
			this.doCloseDialogFormHandler();
			return;
		}
		
		if(mi.prefetch==true)
		{
			this.doCloseDialogFormHandler();
			CommandResolver.resolve(mi.commandResult.tasks,window.formModuleInstance);
		}
		else
		{	
			let arg = CommandResolver.getSendCmd(window.formModuleInstance, defaultGroupAlias, mi);
			let mapEditors = {remoteClass:"java.util.HashMap"};
			CommandActions.diaLogMapEditors(this.props.dialogArg.id,mapEditors);
			arg.argObject = mapEditors;
			if(arg.argObject == null)
				return;
			var command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doDialog", "CommandResult")
				.appendArg(this.props.dialogArg.id).appendArg(cmd).appendArg(arg, "CommandArg");
			let _rpc_result_do_server = this.rpc_result_do_server.bind(this);
			let remoteArg = {command:command,resultFunction:function(data){_rpc_result_do_server(data,group);},sync:false};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
	}

	rpc_result_do_server(data,group)
	{
		this.doCloseDialogFormHandler();
		var result = data.result;
		CommandResolver.resolve(result.tasks, window.formModuleInstance, group);
	}

	componentWillUnmount()
	{
		//alert("DialogForm卸载");
	}
	//<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closeDialogFormHandler.bind(this)}></i>
	/** 
	 * <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} id="userFormSetSaveModal_BtnCancel" data-dismiss="modal" onClick={this.hideQueryFormSetSaveTable.bind(this)}>取消</button>
		<button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}} onClick={this.saveQuerySetForm.bind(this)}>保存</button>
	*/
	render()
	{
		
		let _style = {display:"flex",padding:"10px",backgroundColor:"#ffffff"};
		let _outerStyle = {alignSelf:"center",border:"2px solid #e5e5e5",border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:"2px"};
		if(this.props.dialogArg)
		{
			if(this.props.dialogArg.width)
			{
				_outerStyle.width = this.props.dialogArg.width+"px";
			}
			if(this.props.dialogArg.height)
			{
				_outerStyle.height = this.props.dialogArg.height+"px";
				_outerStyle.display = "flex";_outerStyle.flexDirection = "column";
				_style.flexGrow = 1;
			}
		}
		let _className;
		if(this.state.layout == "vertical"){_style.flexDirection = "column";_className="verticalList";}else {_style.flexDirection = "row";_className="horizontalList"};
		let list = this.getDialogComponents();
		return	(<div ref={node=>this.outterDiv=node} id={"dialog_"+this.props.dialogArg.id} style={_outerStyle}>
	              <div className="modal-header" style={{position:"relative",height:"45px"}}>
				  	<div className="modal-close" onClick={this.closeDialogFormHandler.bind(this)}></div>
	                <h5 className="modal-title">{this.state.title}</h5>
	              </div>
	              <div ref={node => this.dialogComponent = node} style={_style} className={_className}>
	               	{list}
	              </div>
	              <div className="modal-footer" style={{padding:"5px",backgroundColor:"#ffffff",textAlign:"center"}}>
	              	<button style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}} type="button" className="btn" onClick={this.do_server.bind(this,"OK")}>{this.state.okLabel?this.state.okLabel:"确定"}</button>
	                <button style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} type="button" className="btn" data-dismiss="modal" onClick={this.do_server.bind(this,"Cancel")}>{this.state.cancelLabel?this.state.cancelLabel:"取消"}</button>
              	  </div>
	            </div>);
	}
};

DialogForm.defaultProps = {
};

export default DialogForm;



// WEBPACK FOOTER //
// ./src/components/dialog/DialogForm.js